<template>
  <div class="produto-cdlsaude-resumo">
    <div class="content">
      <div class="row">
        <div class="col-6 p-4">
          <Titulo
            title="Resumo"
            description="Confira todos os dados antes de enviar para a conferência."
          />
        </div>
      </div>
      <Resumo :dados="dadosPlano" />
      <div class="row mt-5 flex-column-reverse flex-md-row">
        <div class="col-md-4 col-lg-2 mt-3 mt-md-0">
          <Botao
            title="Voltar"
            link="/produto/spc-conciliador/planos"
            name-class="btn btn-outline-secondary btn-lg btn-block"
          >
            Voltar
          </Botao>
        </div>
        <div class="col-md-5 col-lg-4">
          <Botao
            title="Próximo"
            @click="salvarApi"
            name-class="btn btn-cta btn-lg btn-block font-weight-bold"
          >
            CONFIRMAR
          </Botao>
        </div>
      </div>
      <div class="py-5"></div>
    </div>
  </div>
</template>

<script>
import Titulo from "@/components/TituloPaginas";
import Botao from "@/components/botoes/Botao";
import Resumo from "@/components/resumo/DadosConciliadorResumo";
export default {
  name: "ListaVidas",
  components: { Titulo, Botao, Resumo },
  data() {
    return {
      disable: false,
      produto: {
        nome: "SPC Conciliador",
        id: "spc_conciliador",
      },
      breadcrumb: [
        {
          nome: "SPC Conciliador",
          id: "spc_conciliador",
          link: "/produto/spc-onciliador/painel",
        },
        {
          nome: "Resumo",
          id: "resumo",
        },
      ],
      dadosPlano: null,
    };
  },
  methods: {
    montaDados() {
      this.dadosPlano = JSON.parse(localStorage.getItem("spc_conciliador"));
    },
    async salvarApi() {
      this.$router.push({ name: "termo-conciliador" });
    },
  },
  created() {
    this.$store.commit("UPDATE_PRODUTO", this.produto);
    this.$store.commit("UPDATE_BREADCRUMB", this.breadcrumb);
    this.montaDados();
  },
  filters: {
    currency(valor) {
      var formatter = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
      return formatter.format(valor);
    },
  },
};
</script>
<style lang="scss" scoped>
.produto-cdlsaude-resumo /deep/ {
  @import "@/assets/scss/_vue-formulate.scss";
}
</style>
